export default "__VITE_ASSET__CtzZ4vjU__"